module.exports = __webpack_public_path__ + "static/media/account-mobile.cefc2028.png";